<div class="col-12">
    <div class="row header-row">
        <div class="col">
            <h5>{{"Hospedagem (Opção)" | translate}} {{hotel.Opcao}} <span class="badge badge-primary"
                    *ngIf='hotel.PacoteId != null'>Pacote</span></h5>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col title">
            <strong>{{ hotel.Nome }}</strong>
            <strong *ngIf="empresaId"> {{ ' - ' + hotel.Fornecedor }} </strong>
        </div>
        <div class="col subtitle">
            <strong>{{ noites(hotel.Checkin, hotel.Checkout) }} {{"Noites" | translate}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <h6>{{ hotel.Endereco }}</h6>
            <div class="row mb">
                <div class='col'>
                    <p> {{"Cidade" | translate}}:
                        <span>
                            {{hotel?.Cidade?.Nome}}
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <div class="col">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col flex">
                            <h6>{{'Check-In' | translate}}:</h6>
                            <p>{{ hotel.Checkin | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                    <div class="row flex">
                        <div class="col flex">
                            <h6>{{ "Check-out" | translate}}:</h6>
                            <p>{{ hotel.Checkout | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col flex" [ngSwitch]="hotel.Status">
                            <h6>{{ "Status" | translate}}:</h6>
                            <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">{{"Pendente" |
                                translate}}</span>
                            <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">{{"Aguardando" |
                                translate}}</span>
                            <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">{{"Reserva Parcial" |
                                translate}}</span>
                            <span *ngSwitchCase="3" class="badge rounded-pill bg-success">{{"Reservado" |
                                translate}}</span>
                            <span *ngSwitchCase="4" class="badge rounded-pill bg-success">{{"Solicitado" |
                                translate}}</span>
                            <span *ngSwitchCase="5" class="badge rounded-pill bg-success">{{"Emitido" |
                                translate}}</span>
                            <span *ngSwitchCase="6" class="badge rounded-pill bg-success">{{"Pago" | translate }}</span>
                            <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">{{"Problema Técnico"
                                |
                                translate }}</span>
                            <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">{{"Cancelado" |
                                translate }}</span>
                            <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">{{"Excluído" |
                                translate}}</span>
                            <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">
                                {{"Cancelamento com Problema" | translate }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col flex">
                            <h6>{{"Reembolsável" | translate }}:</h6>
                            <p> {{ hotel.Quartos[0].Reembolsavel ? 'Sim' : 'Não' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="room mt-3 border-bottom">
        @for (quarto of hotel.Quartos; track quarto.Id; let j = $index) {
        <div class="row">
            <div class="col-6 flex">
                <strong>{{"Quarto " + (j + 1) + " / " + quarto.Adultos + " Adulto(s)" | translate }}
                    {{quarto.Criancas > 0 ? "/ " + quarto.Criancas + " Criança(s)" : "" }} :</strong>
            </div>
            <div class="col-6 text-end" *ngIf="quarto.Localizador">
                Loc: <strong>{{ quarto.Localizador }} <p *ngIf="hotel.Agrupador" style="display: inline;">/
                        {{hotel.Agrupador}}</p></strong>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col"><b>{{"Quantidade" | translate }}:</b>
                <p>{{ quarto.Quantidade }}</p>
            </div>
            <div class="col"><b>{{"Apartamento" | translate }}:</b>
                <p>{{ quarto.Descricao | translate }}</p>
            </div>
            <div class="col"><b>{{"Regime" | translate }}: </b>
                <p>{{ quarto.DescricaoPensao | translate }}</p>
            </div>
        </div>
        <div class='row mt-3'>
            <div class="col"><b>{{ "Subtotal" | translate }}: </b>
                <p>{{quarto.MoedaListagem.Simbolo}} {{ quarto.ValorListagem |
                    currency:'BRL':'':'2.2-2' }}</p>
            </div>
            <div class="col"><b>{{ "Prazo Cancelamento" | translate }}: </b>
                <p>{{ quarto.PrazoCancelamento | date: "dd/MM/yyyy" }}</p>
            </div>
            <div class="col">
                <div *ngIf="agenteEmpresaId != null && agenteEmpresaId != '' && agenteEmpresaId != undefined">
                    <b>{{ "Prazo Cancelamento WS" | translate }}:</b>
                    <p>{{ quarto.PrazoCancelamentoWs | date: "dd/MM/yyyy"}}</p>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="quarto.PoliticaCancelamento != '' || quarto.PoliticaCancelamento != null">
            <details>
                <summary><strong>{{"Política de Cancelamento" | translate}}</strong></summary>
                <p class="text-justify" [innerHTML]="quarto.PoliticaCancelamento"></p>
                <!-- <p class="text-justify">{{"Cancelamento: Cancelamento sem multa em até 72h da realização do serviço" | translate}}.</p> -->
            </details>
        </div>
        }
    </div>


    <div class="row">
        <div class="col text-end mt-2">
            <strong>{{ "Total" | translate }}: </strong>
            <strong class="price">{{hotel.Quartos[0].MoedaListagem.Simbolo}} {{hotel.ValorTotalListagem |
                currency:'BRL':'':'2.2-2' }}</strong>
            <!-- <h4>{{hotel.Quartos[0].MoedaListagem.Simbolo}} {{ somaTotal(hotel.Quartos) | currency:'BRL':'':'2.2-2' }}</h4> -->
        </div>
    </div>
    @if (!cardSimplificado) {
    <div class="row footer-row">
        <div class="col text-end">
            <button class="btn btn-outline-danger" (click)="removerHotel()" [disabled]="carregandoObj"
                *ngIf="hotel.Status == 0 || hotel.Status == 8">
                {{ "Excluir" | translate }}
            </button>
            <button class="btn btn-outline-danger" (click)="cancelarHotel(hotel)" [disabled]="carregandoObj"
                *ngIf="hotel.Status == 3 && statusOrcamento!=6">
                {{ "Cancelar" | translate }}
            </button>

            <button *ngIf="hotel.Status == 0" class="btn btn-success" (click)="validaSePodeReservar()">
                {{ "Reservar" | translate }}
            </button>

            <button *ngIf="hotel.Status == (1 || 2 || 10)" class="btn btn-success" [disabled]="hotel.carregando"
                (click)="atualizarStatusHotel(hotel)">{{"Verificar" | translate }}</button>

            <button *ngIf="(hotel.Status == 3 || hotel.Status == 4) && statusOrcamento ==6" class="btn btn-success"
                (click)="imprimirVoucher()" [disabled]="!LiberarVoucher">
                <span *ngIf="!LiberarVoucher" class="fas fa-exclamation-circle"></span>
                <span *ngIf="LiberarVoucher" class="fas fa-check-circle"></span>
                {{LiberarVoucher ? 'Voucher' : 'Voucher Pendente'}}
            </button>
        </div>
    </div>
    }

    @if(mensagensErroHotel.length > 0) {
    <div class="row">
        <div class="col">
            <div class="alert alert-danger" role="alert ">
                <span (click)="mensagensErroHotel = []">
                    <i class="fas fa-times-circle"></i>
                </span>
                <ul>
                    <li *ngFor="let mensagem of mensagensErroHotel">{{ mensagem }}</li>
                </ul>
            </div>
        </div>
    </div>
    }

    @if (mensagemSucessoHotel.length > 0) {
    <div class="row">
        <div class="col">
            <div class="alert alert-success" role="alert">
                <ul>
                    <li>{{ mensagemSucessoHotel }}</li>
                </ul>
            </div>
        </div>
    </div>
    }
</div>

<!-- Defina um ng-template para o conteúdo do modal -->
<ng-template #tplReservaHotel>
    <app-hotel-reserva [hotel]="hotel" (alterou)="atualizarHotel($event)" (fechou)="modalReserva.close()" [idadeInvalida]="idadeInvalida">
    </app-hotel-reserva>
</ng-template>

<!-- Passe o template como input para o app-modal -->
<app-modal #modalReserva
    [modalConfig]="{ titleModal: 'Reservar Hotel', hideCloseButton: true, hideDismissButton: true }"
    [template]="tplReservaHotel">
</app-modal>
